module.exports = __webpack_public_path__ + "img/marc-andre.5bd49f9c.jpg";